module.exports = __webpack_public_path__ + "km.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/km.svg
// module id = 640
// module chunks = 0